import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import RoundIcon from 'components/common/RoundIcon/RoundIcon'
import { A } from 'components/common/Link/Link'
import Theme from 'components/common/Theme/Theme'
import { dynamicDataAttribute } from 'helpers/utils'
import withScrollToAnchor from 'components/common/hoc/withScrollToAnchor'

const StepAppointment = ({ className, children, scrollToAnchorHandler, targetId, isDone, ...props }) =>
  <Block
    data-at-step-appointment-block
    { ...dynamicDataAttribute(`step-${targetId}`) }
    data-at-step-appointment-done={ isDone }
    className={ className }
    { ...props }>
    <AnchorLink anchor href={ `#${targetId}` } prevent handler={ scrollToAnchorHandler }>
      <RoundIcon { ...dynamicDataAttribute(`step-${targetId}-icon`) } { ...props } backgroundColor />
      { children }
    </AnchorLink>
  </Block>

StepAppointment.propTypes = {
  asset: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string,
  isDone: PropTypes.bool,
  scrollToAnchorHandler: PropTypes.func,
  targetId: PropTypes.string
}

export default withScrollToAnchor(StepAppointment)

const Block = styled.div`
  display: table-cell;
  padding: 0 10px;
  text-align: center;
  vertical-align: top;
  ${Media.mobile`
    padding: 0;
    width: 50%;
    margin: 0 0 25px;
  `}
`

const AnchorLink = styled(A)`
  color: ${Theme.colors.black};
  text-decoration: underline;

  :hover {
    text-decoration: underline;
  }
`
